import React from "react";
import { Link } from "react-router-dom";
import "./ComingSoon.css";

function ComingSoon() {
  return (
    <section className="tv-coming-soon">

      <div className="tv-coming-glow tv-coming-glow-one"></div>
      <div className="tv-coming-glow tv-coming-glow-two"></div>

      <div className="tv-coming-container">

        <Link to="/" className="tv-coming-logo">
          <img
            src="/images/logo.png"
            alt="Time Valley Watches"
          />
        </Link>

        <span className="tv-coming-eyebrow">
          TIME VALLEY WATCHES
        </span>

        <div className="tv-coming-line"></div>

        <h1>
          Something
          <br />
          <span>Timeless Is Coming.</span>
        </h1>

        <p>
          We are carefully preparing this experience for you.
          <br />
          Please check back soon.
        </p>

        <Link to="/" className="tv-coming-button">
          Back To Home
          <span>→</span>
        </Link>

      </div>

      <div className="tv-coming-corner">
        TIME VALLEY
      </div>

    </section>
  );
}

export default ComingSoon;